import React from 'react';
import i18n from 'i18n-react';

import { ContentHeader } from 'components/ContentHeader/ContentHeader';
import SocialIcons from 'components/SocialIcons/SocialIcons';
import Toolbox from 'components/Toolbox';

const ToolboxView = () => {
  return (
    <div className="contentContainer toolboxView" data-testid="toolbox-view">
      <ContentHeader
        header={i18n.translate('nav.sell')}
        subtitle={i18n.translate('pageDescriptions.sell')}
        line
        pageHeader
      >
        <SocialIcons />
      </ContentHeader>
      <Toolbox />
    </div>
  );
};

export default ToolboxView;
